type LatLng = { lat: number; lng: number };

// shifts the whole path by one constant pixel vector. a per-point
// perpendicular offset looks jittery on dense, unevenly spaced GPS points,
// whereas a rigid shift keeps the shape intact. recomputed on zoom change,
// since the pixel-to-world ratio depends on it.
export const offsetPathByPixels = (
  map: any,
  path: LatLng[],
  offsetXPixels: number,
  offsetYPixels: number,
  zoom: number
): LatLng[] => {
  const google = (window as any).google;
  const projection = map.getProjection?.();
  if (!projection || path.length === 0) return path;
  if (offsetXPixels === 0 && offsetYPixels === 0) return path;

  const scale = Math.pow(2, zoom);
  const worldDx = offsetXPixels / scale;
  const worldDy = offsetYPixels / scale;

  return path.map((point) => {
    const worldPoint = projection.fromLatLngToPoint(
      new google.maps.LatLng(point.lat, point.lng)
    );
    const shifted = new google.maps.Point(
      worldPoint.x + worldDx,
      worldPoint.y + worldDy
    );
    const latLng = projection.fromPointToLatLng(shifted);
    return { lat: latLng.lat(), lng: latLng.lng() };
  });
};
